/** @jsx jsx */
import { Container } from "react-bootstrap"

import { jsx } from "@emotion/react"
import { oJeitoVersar } from '../assets/styles/OJeitoVersar.styles'
import Card from './card'

import Ebook from '../assets/images/LP-versar/ebook-hand.png'
import EbookMobile from '../assets/images/LP-versar/oebook-hand-mobile.png'


const OEbookContent = () => {

  return (
    <section css={oJeitoVersar}>
      <Container style={{position: 'relative'}}>
        <div className='title-container'>
          <h2 data-aos="fade-down" data-aos-delay="500" className='title'>
            O que você verá neste <span>e-book:</span>
          </h2>
        </div>
        <img src={EbookMobile} className="ebook-hand-mobile" alt="Ebook" />
        <div className="topics">
          <ul>
            <li>O papel das redes sociais para o marketing educacional</li>
            <li>Os pilares estratégicos: alcance, frequência e consistência</li>
            <li>Erros mais comuns nas redes e como evitá-los</li>
            <li>Exemplos práticos de escolas parceiras</li>    
          </ul>
        </div>
        <img src={Ebook} className="ebook-hand" alt="Ebook" />
        
        {/* <div className='cards-container'>
          <div data-aos="fade-left" data-aos-delay="500">
            <Card
              img={Imagem1}
              text='Cultura socioemocional: o que é e como fortalece a identidade da comunidade escolar'
            />
          </div>
          <div data-aos="fade-right" data-aos-delay="600">
            <Card
              img={Imagem2}
              text='Atividades práticas para aplicar em sala de aula hoje mesmo'
            />
          </div>
          <div data-aos="fade-left" data-aos-delay="700">
            <Card
              img={Imagem3}
              text='O valor do socioemocional como investimento estratégico'
            />
          </div>
          <div data-aos="fade-right" data-aos-delay="800">
            <Card
              img={Imagem4}
              text='Dica bônus: como dar início à cultura socioemocional escolar'
            />
          </div>
        </div> */}
      </Container>
    </section>
  )
}

export default OEbookContent
